import complaintFeHtml from './complaintFe.html';

class complaintFeController {
    constructor($scope, $http, $timeout, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$timeout = $timeout;

        this.translate = translateService;

        this.loading = true;
        this.orderLoaded = false;
        this.complaintSent = false;

        this.complaintId = null;

        this.orderNumber = null;
        this.orderEmail = null;
        this.checkDataError = false;
        this.checkDataSuccess = false;

        this.order = null;
        this.complaint = null;

        this.message = null;
        this.messageFiles = [
            {
                file: null
            }
        ];
        this.allowedMimeTypes = ['image/jpeg', 'image/gif', 'image/png', 'application/pdf', 'application/x-pdf', 'application/acrobat', 'applications/vnd.pdf', 'text/pdf', 'text/x-pdf'];
        this.allowedExtensions = ['jpg', 'jpeg', 'gif', 'png', 'pdf'];
        this.messageError = false;
        this.messageSuccess = false;

        this.init();

        $scope.$watch(() => this.complaintId, (newVal, oldVal) => {
            if (newVal === null || typeof newVal === 'undefined' || newVal === false || newVal === 0) {
                return;
            }

            this.loadComplaint();
        });
    }

    init() {
        this.loading = false;
    }

    loadComplaint() {
        this.loading = true;

        this.$http.get('/user/complaints/ajax/complaint/' + this.complaintId, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.checkDataSuccess = false;
                    this.checkDataError = response.data.message;

                    this.$timeout(() => {
                        this.checkDataError = false;
                    }, 5000);
                } else {
                    this.orderLoaded = true;
                    this.order = response.data.order;
                    this.complaint = response.data.complaint;
                    this.orderNumber = this.order.order_number;
                    this.orderEmail = this.order.order_email;
                }
            },
            () => {
                this.loading = false;

                this.checkDataSuccess = false;
                this.checkDataError = this.translate.t('complaint.errors.unexpected');

                this.$timeout(() => {
                    this.checkDataError = false;
                }, 5000);
            }
        );
    }

    checkData() {
        if ((this.orderNumber === '' || this.orderNumber  === null) || (this.orderEmail === '' || this.orderEmail  === null)) {
            this.checkDataError = this.translate.t('complaint.errors.emptyFields');

            return;
        }

        this.checkDataError = false;
        this.loading = true;

        this.$http.post('/ajax/complaints/checkData', {order_number: this.orderNumber, order_email: this.orderEmail}, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.checkDataError = response.data.message;

                    this.$timeout(() => {
                        this.checkDataError = false;
                    }, 5000);
                } else {
                    this.checkDataSuccess = true;
                    if (response.data.complaint === true) {
                        this.confirmData();
                    }
                }
            },
            () => {
                this.loading = false;

                this.checkDataError = this.translate.t('complaint.errors.unexpected');

                this.$timeout(() => {
                    this.checkDataError = false;
                }, 5000);
            }
        );
    }

    confirmData() {
        this.loading = true;

        this.$http.post('/ajax/complaints/confirmData', {order_number: this.orderNumber, order_email: this.orderEmail}, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.checkDataSuccess = false;
                    this.checkDataError = response.data.message;

                    this.$timeout(() => {
                        this.checkDataError = false;
                    }, 5000);
                } else {
                    this.orderLoaded = true;
                    this.order = response.data.order;
                    this.complaint = response.data.complaint;
                }
            },
            () => {
                this.loading = false;

                this.checkDataSuccess = false;
                this.checkDataError = this.translate.t('complaint.errors.unexpected');

                this.$timeout(() => {
                    this.checkDataError = false;
                }, 5000);
            }
        );
    }

    addMessageFile() {
        this.messageFiles.push({
            file: null
        });
    }

    removeMessageFile(index) {
        this.messageFiles.splice(index, 1);
    }

    sendTicket() {
        if (this.message === '' || this.message  === null) {
            this.messageError = this.translate.t('complaint.errors.emptyMessage');

            return;
        }

        const _this = this;
        this.loading = true;

        let messageFilesErrors = [];
        angular.forEach(this.messageFiles, function(value, key) {
            if (value.file !== null) {
                if (_this.allowedMimeTypes.indexOf(value.file.fileType) == -1) {
                    messageFilesErrors.push(_this.translate.t('complaint.errors.invalidExtension', {attachment: (key + 1), allowedExtensions: 'JPG, GIF, PNG, PDF'}));
                }

                if (value.file.fileSize > 10000240) {
                    messageFilesErrors.push(_this.translate.t('complaint.errors.maximumFileSize', {attachment: (key + 1), filesize: '10 MB'}));
                }
            }
        });
        if (messageFilesErrors.length > 0) {
            this.messageError = messageFilesErrors.join("\r\n");
            this.loading = false;
            return;
        }

        this.messageError = false;

        const formData = new FormData();

        formData.append('complaint_id', this.complaint.id);
        formData.append('order_number', this.orderNumber);
        formData.append('order_email', this.orderEmail);
        formData.append('message', this.message);

        angular.forEach(this.messageFiles, function(value, key) {
            if (value.file !== null) {
                formData.append('files[]', value.file.fileFormData.get('file'));
            }
        });

        this.$http.post('/ajax/complaints/sendTicket', formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.messageError = response.data.message;

                    this.$timeout(() => {
                        this.messageError = false;
                    }, 5000);
                } else {
                    this.messageSuccess = this.translate.t('complaint.messageSent');
                    this.complaintSent = true;

                    this.$timeout(() => {
                        this.messageSuccess = false;
                    }, 5000);

                    this.complaint.id = response.data.complaint_id;

                    this.complaint.tickets.unshift(response.data.ticket);

                    this.message = null;
                    this.messageFiles = [
                        {
                            file: null
                        }
                    ];
                }
            },
            () => {
                this.loading = false;

                this.messageError = this.translate.t('complaint.errors.unexpected');

                this.$timeout(() => {
                    this.messageError = false;
                }, 5000);
            }
        );
    }
}

let complaintFeComponent = {
    bindings: {
        'complaintId': '<'
    },
    template: complaintFeHtml,
    controller: complaintFeController
};

export default complaintFeComponent;
